import React from 'react';
import {connect} from "react-redux";

const NavBar = ({global}) => {

  return <nav className="navbar sticky-top navbar-dark bg-dark">
    <span className="navbar-brand">Otegaru net Mobile</span>
    {global.showError && <span className="navbar-text text-warning">サービスエラー</span>}
    <a className="nav-link" href="/logout">ログアウト</a>
  </nav>;
}

const mapState = state => ({
  global: state.global
});

const mapDispatch = dispatch => ({
});

export default connect(mapState, mapDispatch)(NavBar);
